import { ComponentType, SVGProps } from "react"

import { IconName, getIconFileName, iconNames } from "hived-theme/lib/iconList"

type SvgComponent = ComponentType<SVGProps<SVGSVGElement> & { title?: string }>

const svgModules = import.meta.glob<{ default: SvgComponent }>(
  "/node_modules/hived-theme/lib/assets/icons/*.svg",
  { query: "?react", eager: true },
)

function findModule(fileName: string): SvgComponent | undefined {
  for (const [key, mod] of Object.entries(svgModules)) {
    if (key.endsWith(`/${fileName}`)) {
      return mod.default ?? (mod as unknown as SvgComponent)
    }
  }
  return undefined
}

const iconList: Record<IconName, SvgComponent> = iconNames.reduce(
  (acc: Record<string, SvgComponent>, iconName) => {
    const component = findModule(getIconFileName(iconName))
    if (component) acc[iconName] = component
    return acc
  },
  {},
)

export default iconList
